import { defineMessages } from 'react-intl';

export default defineMessages({
	inputValidationErrorMessage: {
		defaultMessage: `The label \u2019{labelInput}\u2019 can't contain spaces`,
		description: 'Request form labels input error validation messages',
		id: 'sd.customerview.field.labels.error.validation',
	},
});
